import { useSession } from "@outschool/ui-auth";
import { useNavigation } from "@outschool/ui-utils";
import { useCallback } from "react";
import { useLocation } from "react-router";

import {
  CONCIERGE_FEATURE_FLAGS,
  CONCIERGE_URL_PARAMS
} from "../components/concierge/constants";
import { useFeatureFlag } from "../lib/FeatureFlags";

type UseConcierge = {
  canAccessConcierge: boolean;
  shouldShowConciergeEntry: boolean;
  closeConciergeModal: () => void;
};

export default function useConcierge(): UseConcierge {
  const { isLoggedIn } = useSession();
  const navigate = useNavigation();
  const location = useLocation();

  const canAccessConcierge = isLoggedIn;

  const closeConciergeModal = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete(CONCIERGE_URL_PARAMS.OPEN_CONCIERGE);
    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true
    });
  }, [location.search, location.pathname, navigate]);

  const conciergeEntryFeatureFlag = useFeatureFlag(
    CONCIERGE_FEATURE_FLAGS.ENTRY
  );

  const shouldShowConciergeEntry =
    canAccessConcierge && conciergeEntryFeatureFlag;

  return {
    canAccessConcierge: !!canAccessConcierge,
    shouldShowConciergeEntry: !!shouldShowConciergeEntry,
    closeConciergeModal
  };
}
